import { AlertType } from '@yme/atoms/alert';
export const CERTIFICATE_CODE = 'certificateCode';
export const CYCLE_SCHEME_VALUE = 'cyclescheme';
export const SUPPORT_EMAIL = 'customersupport@yamaha-motor.co.uk';
export const EMAIL_PREFIX = 'mailto:';
export const CERTIFICATE_INPUT_PLACEHOLDER = 'Enter certificate code';
export const CERTIFICATE_INPUT_LABEL = 'Certificate Code';
export const CYCLE_SCHEME_DESCRIPTION = 'Cycle to work salary sacrifice scheme';
export const TEXT_CERTIFICATE_AGREEMENT = 'I want to proceed with cart total less than certificate value.';
export const CERTIFICATE_CODES = {
    invalid: 'There is something wrong with your certificate. Please check the code or contact {email} for further support',
    below: 'Your certificate is valid, but cart total exceeds certificate value. You can make changes to your cart and try again.',
    match: 'Certificate code verification completed successfully.',
    exceed: 'Certificate code verification completed successfully. Please be aware that value of certificate exceeds the amount of your cart. You can proceed but this will result in the loss of excess certificate funds.',
};
export const REDEMPTION_MODAL_TEXT = {
    title: 'Pay & place order',
    info: 'You are going to pay & place order using Cyclescheme leasing certificate.',
};
export const CODES = ['below', 'match', 'exceed'];
export const ALERT_TYPE = {
    below: AlertType.ERROR,
    exceed: AlertType.INFO,
    match: AlertType.SUCCESS,
    invalid: AlertType.ERROR,
};
export const VALIDATION_SCHEME_MESSAGE = {
    max: 'Password must be at least {0} characters',
    wrongFormat: 'Wrong certificate code format',
};
export var CERTIFICATE_STATUS;
(function (CERTIFICATE_STATUS) {
    CERTIFICATE_STATUS["invalid"] = "invalid";
    CERTIFICATE_STATUS["exceed"] = "exceed";
    CERTIFICATE_STATUS["match"] = "match";
})(CERTIFICATE_STATUS || (CERTIFICATE_STATUS = {}));
export var REDEMPTION_STATUS;
(function (REDEMPTION_STATUS) {
    REDEMPTION_STATUS["success"] = "success";
    REDEMPTION_STATUS["failed"] = "failed";
})(REDEMPTION_STATUS || (REDEMPTION_STATUS = {}));
